import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Receivables from "../../Partials/Charge/Receivables";
import Payables from "../../Partials/Charge/Payables";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import { Radio, RadioGroup } from "@material-ui/core";
import { TabsComponent } from "./TabsComponent";

class Charge extends Component {
  public state = {
    isReceivables: true,
  };

  constructor(public props) {
    super(props);
  }

  public changeOption = (): void => {
    this.setState({
      isReceivables: !this.state.isReceivables,
    });
  };

  public renderRadioGroup = () => {
    const countForReceivables =
      this.props.app?.dashboardReceivableChargesCount > 0
        ? ` (${this.props.app?.dashboardReceivableChargesCount})`
        : "";
    const countForPayables =
      this.props.app?.dashboardPayableChargesCount > 0
        ? ` (${this.props.app?.dashboardPayableChargesCount})`
        : "";

    return (
      <RadioGroup
        name="paymentsFilters"
        onChange={this.changeOption}
        style={{
          display: "flex",
          flexDirection: "row",
          marginRight: "15px",
        }}
      >
        <FormControlLabel
          value="receivable"
          control={<Radio color="primary" />}
          label={
            <span>{this.trans("page/receivables") + countForReceivables}</span>
          }
          checked={this.state.isReceivables}
        />
        <FormControlLabel
          value="payable"
          control={<Radio color="primary" />}
          label={<span>{this.trans("page/payables") + countForPayables}</span>}
          checked={!this.state.isReceivables}
        />
      </RadioGroup>
    );
  };

  public render() {
    return (
      <div className="state-app">
        hola
        <div
          className={`box box-full component-dashboard has-general-page-header with-tabs bottom-whitespace ${
            this.props.app?.settings?.user?.launchPanelState
              ? "with-launchpanel"
              : ""
          }`}
        >
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent activeTab={3} {...this.props} />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div
                className="label-container two-row-title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px",
                }}
              >
                <h3
                  className="card-title"
                  style={{ flexDirection: "column", display: "flex" }}
                >
                  {this.state.isReceivables
                    ? this.trans("title-receivable-charges-unpaid-dashboard")
                    : this.trans("title-payable-charges-unpaid-dashboard")}
                  <span
                    onClick={() => this.redirect("/app/finance/charge")}
                    className="dashboard-link-title"
                  >
                    {this.trans("link-to-all-charges")}
                  </span>
                  <h4 className="dashboard-subtitle">
                    {this.trans("dashboard-charges/subtitle")}
                  </h4>
                </h3>
              </div>

              {this.state.isReceivables ? (
                <Receivables
                  {...this.props}
                  renderRadioGroup={this.renderRadioGroup}
                />
              ) : (
                <Payables
                  {...this.props}
                  renderRadioGroup={this.renderRadioGroup}
                />
              )}
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.charge,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(Charge);
